import { render, staticRenderFns } from "./ContentsEdit.vue?vue&type=template&id=4a8d7f59"
import script from "./ContentsEdit.vue?vue&type=script&lang=js"
export * from "./ContentsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports